import PropTypes from 'prop-types';

/**
 * MetricContent component - Displays metric name-value-unit combinations
 * In the grid layout, value+unit is displayed in the title (handled by AMFIItem)
 * and name is displayed in the content
 */

// TODO: use formatMetricValue and remove linter disable line, or remove it
// eslint-disable-next-line no-unused-vars
const MetricContent = ({ item, formatName, formatMetricValue }) => {
	// Get the appropriate name to display
	const displayName = formatName(item.metric_name || item.name || '');

	return (
		<div className='metric-content'>
			<div
				className='metric-name'
				style={{
					fontSize: '0.9rem',
					fontWeight: '500',
					color: '#555',
					wordBreak: 'break-word',
				}}
			>
				{displayName}
			</div>
		</div>
	);
};

MetricContent.propTypes = {
	item: PropTypes.shape({
		id: PropTypes.string.isRequired,
		name: PropTypes.string,
		metric_name: PropTypes.string,
		value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		unit: PropTypes.string,
		category: PropTypes.string,
		is_key: PropTypes.bool,
		source: PropTypes.string,
	}).isRequired,
	formatName: PropTypes.func.isRequired,
	formatMetricValue: PropTypes.func.isRequired,
};

export default MetricContent;
